import type { UploadFile } from "antd";

// Sentinel `clientId` that equates to "all clients" on submit. Stored as a
// number to keep the form schema and AntD Select happy without a `number | null`union;
// serialized to undefined before the API call (no 'clientId' in database is equivalent to available to all clients).
export const ALL_CLIENTS = 0;

export interface SelectedTest {
  testId: number;
  normId?: number;
}

export interface TemplateFormData {
  templateName: string;
  clientId: number;
  landingImageFile?: UploadFile;
  landingText: string;
  tests: SelectedTest[];
  formulas: string;
  zipFile?: UploadFile;
}
